<template>
	<div class="details">
		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Pacient') }}</h1>
			<div>
				<p v-if="request" class="details__item__desc" >
					<span class="details__item__desc underline cursor-pointer" v-if="isEnabledPatientDetail" @click="openPatientDetail">{{ patientUtils.getFullName(request.patient) }}</span>
					<span class="details__item__desc" v-else >{{ patientUtils.getFullName(request.patient) }}</span>
				</p>
				<div v-else class="skelet w-[130px] h-[20px]"></div>
			</div>
		</div>
		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Rodné číslo') }}</h1>
			<p v-if="request" class="details__item__desc">{{ request.patient?.personal_id || '-' }}</p>
			<div v-else class="skelet w-[90px] h-[20px]"></div>
		</div>
		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Dátum narodenia') }}</h1>
			<p v-if="request" class="details__item__desc">{{ patientUtils.formatBirthday(request.patient?.birth_date) || '-' }}</p>
			<div v-else class="skelet w-[80px] h-[20px]"></div>
		</div>
		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Pohlavie') }}</h1>
			<p v-if="request" class="details__item__desc">{{ patientUtils.getSex(request.patient?.sex, $t) || '-' }}</p>
			<div v-else class="skelet w-[80px] h-[20px]"></div>
		</div>
		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Poisťovňa') }}</h1>
			<div v-if="request" class="details__item__desc">
				<p>{{ insuranceCompany || '-' }}</p>
			</div>
			<div v-else class="skelet w-[70px] h-[20px]"></div>
		</div>
		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Odporúčajúci lekár') }}</h1>
			<p v-if="request" class="details__item__desc">{{ request.examination_request?.recommending_doctor?.a_code || '-' }} / {{ request.examination_request?.recommending_doctor?.p_code || '-' }}</p>
			<div v-else class="skelet w-[150px] h-[20px]"></div>
		</div>
		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Odosielajúci lekár') }}</h1>
			<p v-if="request" class="details__item__desc">{{ request.examination_request?.sending_doctor?.a_code || '-' }} / {{ request.examination_request?.sending_doctor?.p_code || '-' }}</p>
			<div v-else class="skelet w-[150px] h-[20px]"></div>
		</div>

		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Čas odberu') }}</h1>
			<p v-if="request" class="details__item__desc w-[86%]">{{ formatDate(request.examination_request?.sampling_time) || '-' }} o {{ formatTime(request.examination_request?.sampling_time) || '-' }}</p>
			<p v-else class="skelet w-[200px] h-[22px]"></p>
		</div>

		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Poznámka k objednávke') }}</h1>
			<p v-if="request" class="details__item__desc w-[86%]">{{ request?.order_note || '-' }}</p>
			<p v-else class="skelet w-[130px] h-[22px]"></p>
		</div>

		<div class="details__item">
			<h1 class="details__item__title">{{ $t('Poznámka k žiadanke') }}</h1>
			<p v-if="request" class="details__item__desc w-[86%]">{{ request.examination_request?.note || '-' }}</p>
			<p v-else class="skelet w-[130px] h-[22px]"></p>
		</div>
	</div>
</template>

<script>
import { formatDate, formatTime } from '@/plugins/app/utils/date.utils'
import { modalController } from '@ionic/vue'
import patientUtils from '@/plugins/lib@patient/utils/patient.utils'

export default {
	props: {
		request: {
			type: [Object, null],
			default: null
		},

		patientId: {
			type: [Number, String, null],
			default: null
		}
	},

	data() {
		return {
			patientUtils,
			formatDate,
			formatTime
		}
	},

	computed: {
		insuranceCompany() {
			return this.request?.patient?.insurance?.insurance_company || this.request?.patient?.insurance?.insurance_company_data?.name
		},

		isEnabledPatientDetail() {
			if (this.request?.order === undefined) {
				return false;
			}

			return !!this.request?.order?.request?.patient.id
		}
	},

	methods: {
		openPatientDetail() {
			if (!this.patientId) return

			modalController.dismiss({ role: 'dismiss' })
			this.$router.push({ name: 'Patients - Detail', params: { patientId: this.patientId } })
		}
	}
}
</script>

<style lang="sass" scoped>
@import '@/plugins/app/theme/_mixins/responsive.mixin'
.details
	@apply grid grid-cols-3 pt-[20px] mb-[25px] gap-x-[10px]

	+md
		@apply grid-cols-2 gap-x-[20px]

	&__item
		@apply mb-[25px]

		&__title
			@apply text-[11px] text-[--ion-color-secondary] font-bold uppercase opacity-50 leading-snug tracking-widest

		&__underlined
			@apply cursor-pointer underline

		&__desc
			@apply text-[14px] text-[--ion-color-secondary]

		&__debtor
			p
				@apply text-[--ion-color-secondary]  inline-block

			ion-icon
				@apply w-[20px] h-[20px] inline-block -mb-[4px]
</style>
